var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-toggle-container space-x-8"},[_c('v-switch',{attrs:{"color":_vm.findColor(),"input-value":_vm.value,"disabled":_vm.type === 'disabled',"height":"10px","hide-details":_vm.hideDetails},on:{"change":_vm.onClick}}),_c('label',{staticClass:"label-style",style:(`color: ${_vm.findColor()}`)},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }